module.exports = __webpack_public_path__ + "img/pricing_salon.c24e1bff.svg";